import { render, staticRenderFns } from "./AppointmentWorkersList.vue?vue&type=template&id=0010af3b"
import script from "./AppointmentWorkersList.vue?vue&type=script&lang=ts"
export * from "./AppointmentWorkersList.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentWorkersList.vue?vue&type=style&index=0&id=0010af3b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports